import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=3a83f3f2&"
import script from "./AppLoader.vue?vue&type=script&lang=ts&"
export * from "./AppLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppLoader.vue"
export default component.exports